<template>
  <div class="home">
    <!-- App Title  -->
    <AppTitle></AppTitle>


    <div class="main">

      <p>Hi!</p>
      <h2>Son Ah <span>Young</span></h2>
      <h3><span class="type-it"></span></h3>
    </div>
  </div>
</template>

<script>
import AppTitle from './component/Header.vue';
export default {
  name: "Home",
  components: {
    AppTitle
  },
  mounted() {
    this.typeEffect();
    this.menuAct3();
  },
  methods: {
    typeEffect() {
      $('.type-it').typeIt({
        strings: ['New Web Publisher', 'Innovative Designer', 'Trustworthy Publisher'],
        loop: true,
        breakLines: false,
        cursor: false,
        cursor: true,
        cursorSpeed: 800,
        speed: 100
      });
    },
    menuAct3() {
      $('.Home').removeClass('menu-act');
      $('.Home').addClass('menu-act');
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/_mixin.scss", "../sass/partials/variable.scss";

.home {
  background: url(../assets/images/home3.jpg)no-repeat left top / cover;
  background-attachment: fixed;
  position: relative;
  background-position: 0 0;

  .main {
    position: fixed;
    top: calc(50% - 50px);
    left: 20px;
    color: #fff;

    p {
      @include font-set(bold, 23px, 28px, $ff2);
    }

    h2 {
      @include font-set(bold, 45px, 54px, $ff4);
      margin: 10px 0;

      span {
        color: $m-bg1;
      }
    }

    h3 {
      @include font-set(300, 23px, 28px, $ff4);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue